<template>
  <div class="mb-3">
    <div v-if="question.type === 'text'">
      <label class="form-label my-3" :for="kebabCase(question.title)">
        {{ question.title }}
      </label>
      <input
        :id="kebabCase(question.title)"
        class="form-control"
        :class="{ 'is-invalid': hasError }"
        :type="question.inputType || 'text'"
        :name="kebabCase(question.title)"
        :placeholder="question.placeholder"
        :required="question.required"
        v-model="question.value"
      />
    </div>
    <div v-else-if="question.type === 'textarea'">
      <label class="form-label my-3" :for="kebabCase(question.title)">
        {{ question.title }}
      </label>
      <textarea
        class="form-control"
        :class="{ 'is-invalid': hasError }"
        :id="kebabCase(question.title)"
        :name="kebabCase(question.title)"
        :placeholder="question.placeholder"
        v-model="question.value"
      ></textarea>
    </div>
    <div v-else-if="question.type === 'select'">
      <label class="form-label my-3" :for="kebabCase(question.title)">
        {{ question.title }}
      </label>
      <select
        :id="kebabCase(question.title)"
        :name="kebabCase(question.title)"
        class="form-select"
        :class="{ 'is-invalid': hasError }"
        aria-label="Default select example"
        v-model="question.value"
      >
        <option v-if="question.placeholder" value="">{{ question.placeholder }}</option>
        <option v-for="option in question.options" :key="option.value" :value="kebabCase(option.label)">{{ option.label }}</option>
      </select>
    </div>
    <div v-else-if="question.type === 'checkbox'">
      <label class="form-label my-3">{{ question.title }}</label>
      <div v-for="option in question.options" :key="kebabCase(option.label)" class="form-check">
        <input
          :key="`checkbox_${kebabCase(option.label)}`"
          class="form-check-input"
          :class="{ 'is-invalid': hasError }"
          type="checkbox"
          :id="`checkbox_${kebabCase(option.label)}`"
          :value="kebabCase(option.label)"
          @input="triggerInput"
          v-model="selected[kebabCase(option.label)]"
        />
        <label class="form-check-label" :for="`checkbox_${kebabCase(option.label)}`">{{ option.label }}</label>
      </div>
    </div>
    <div v-else-if="question.type === 'separator'" class="">
      <div v-html="snarkdown(question.title)"></div>
    </div>
  </div>
</template>

<script>
import snarkdown from 'snarkdown'
import { kebabCase } from 'lodash'

export default {
  props: ['question', 'value', 'hasError'],
  data: () => ({
    selected: {},
  }),
  methods: {
    kebabCase,
    triggerInput() {
      this.question.value = this.selected
    },
    snarkdown(text) {
      if (text) {
        return snarkdown(text)
      }
      return ''
    },
  }
}
</script>

<style></style>
